import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../generic/search/Request';

export const Request = BaseRequest({
	sortFields: constants.fpc.opensearch.sortFields,
	columnFields: constants.fpc.opensearch.columnFields,
	standardFilterFields: constants.fpc.opensearch.standardFilterFields,
	dateFilterFields: constants.fpc.opensearch.dateFilterFields,
	stageStatusFilterFields: [] as const,
	booleanFilterFields: [] as const,
});
